
jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
    };
    
    if(isSmallMobile.any()) {
		
		// Close mobile menu if clicked outside of menu
		$("html").on('click', '#whitewrap.open-menu', function(e) {
			if (
				($(e.target).closest('#menu-toggle').length === 0)
				&& ($(e.target).closest('#side-bar-menu').length === 0)
			) { 
				e.preventDefault();
				$('#whitewrap').removeClass('open-menu');
				$('#menu-toggle').removeClass('active');
			}
		})
		
	}

    //HEADER HAMBURGER MENU
	$('#menu-toggle').on('click', function () { 
		$('#menu-toggle').toggleClass('active');
		$('#search-toggle').removeClass('active');
		if ($(window).width() <= 1024) {
			$('#whitewrap').toggleClass('open-menu');
		}
	});
    //END OF HEADER HAMBURGER MENU

      
    $('#header-bottom .header-wrapper .search-toggle-button').on('click', function () {
		$('#search-toggle').toggleClass('active');
		$('#menu-toggle').removeClass('active');
		$('#menu-top-menu > .menu-item').removeClass('active');
		$('#alg-search').typeahead('close');
		$('.dealer-logo').toggleClass('active');
	});

	$('#alg-search').on('input', function (e) {
	    $(this).off('blur');
	});

	// What Are You Looking For button
	$('#looking-for-select').on('change', function() {
		var target = $(this).val();
		var button = $('#looking-for-submit');
		if (target) {
			button.attr('href', target);

			// Open in new window if link starts with https:// or http://
			if (target.indexOf('http://') >= 0 || target.indexOf('https://') >= 0) {
				button.attr('target', '_blank');
			} else {
				button.attr('target', '_self');
			}
		}
	})

	// SC 00334254
	$('.incentives.incentives-breakdown.cash-incentives-breakdown')
		.attr('rel', 'popover')
		.attr('data-title', 'Kia Customer Cash')
		.attr('data-content', 'Retail customers may be eligible for cash incentive. Incentive may not be combined with KIA Motor Finance Lease or Special APR financing. Residency restrictions apply.')
		.attr('data-trigger', 'hover')
		.attr('data-placement', 'left')
		.attr('data-container', 'body');

	//503514  add mobile nav 3 layers deep
	if ($(window).width() < 1025) {
        $('ul.nav > li > ul > li.menu-item-has-children > a').append('<span class="caret"></span>')
        $('ul.nav > li > ul > li.menu-item-has-children > a').click(function (e) {
          if ($(this).next('ul').is(":visible") == false) {
            $(this).next('ul').show();
          } else {
            $(this).next('ul').hide();
          }
          return false;
        })
      }
	// 503514end 
	
//00544841
if ( $(".page-vehicle-display-page").length ) {
	 $("a.cta-button.button.block.buy").insertAfter("a.cta-button.button.roadster-btn.block");
}
//end 00544841

// OMS-1162 vehicle type dropdown ordering fix make sure New is top of the Type list on searches
    $("body").on('search_filters_rendered',function(){
        $( ".filters .type" ).each(function( index ) {
            var NewVehiclesOption = $(this).find('option[value="New"]');
            $(NewVehiclesOption).insertAfter($(this).find('option:first-child'));
        });
    });
    $("body").on('search_filters_rendered',function(){
        $( ".searchfields .type" ).each(function( index ) {
            var NewVehiclesOption = $(this).find('option[value="New"]');
            $(NewVehiclesOption).insertAfter($(this).find('option:first-child'));
        });
    });
// end OMS-1162

$('.home .hidden-xs .di-slide-overlay').insertBefore('.slider512-slider.kia-1400x512-slider');

});
